import { useApiClient } from '../useApi/useApiClient';
import {
    IRecoveryPasswordRequest,
    IRecoveryPasswordResponse,
} from '@/hooks/api/useRecoveryPassword/useRecoveryPassword.interfaces';

export const useRecoveryPassword = () => {
    const { fetch, loading } = useApiClient<IRecoveryPasswordResponse>();

    const recover = async (request: IRecoveryPasswordRequest) =>
        await fetch({
            url: '/recover-password',
            method: 'POST',
            body: request,
        });

    return {
        recover,
        loading,
    };
};
